import UserDriverDownloadRequest, {
  UserDriverDownloadRequestOrder,
  UserDriverDownloadRequestStatusCriteria,
  UserDriverDownloadRequestTimezone,
} from "../../../../api/raily/user/driver/download/user-driver-download.request";
import Timezone from "../../../../types/timezone";
import UserStatus from "../../../../types/user-status";
import UserDriverDownloadParams, {
  UserDriverDownloadParamsOrder,
} from "./user-driver-download-params";

const createTimezone = (
  timezone: Timezone | undefined,
): UserDriverDownloadRequestTimezone | undefined => {
  switch (timezone) {
    case Timezone.EUROPE_WARSAW:
      return UserDriverDownloadRequestTimezone.EUROPE_WARSAW;
    case Timezone.UTC:
      return UserDriverDownloadRequestTimezone.UTC;
    default:
      return undefined;
  }
};

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserDriverDownloadRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserDriverDownloadRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserDriverDownloadRequestStatusCriteria.DELETED;
    default:
      return UserDriverDownloadRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserDriverDownloadParamsOrder | undefined,
): UserDriverDownloadRequestOrder | undefined => {
  switch (status) {
    case UserDriverDownloadParamsOrder.FIRST_NAME_ASC:
      return UserDriverDownloadRequestOrder.FIRST_NAME_ASC;
    case UserDriverDownloadParamsOrder.FIRST_NAME_DESC:
      return UserDriverDownloadRequestOrder.FIRST_NAME_DESC;
    case UserDriverDownloadParamsOrder.LAST_NAME_ASC:
      return UserDriverDownloadRequestOrder.LAST_NAME_ASC;
    case UserDriverDownloadParamsOrder.LAST_NAME_DESC:
      return UserDriverDownloadRequestOrder.LAST_NAME_DESC;
    case UserDriverDownloadParamsOrder.TAXI_CORPORATION_DISPLAY_NAME_ASC:
      return UserDriverDownloadRequestOrder.TAXI_CORPORATION_DISPLAY_NAME_ASC;
    case UserDriverDownloadParamsOrder.TAXI_CORPORATION_DISPLAY_NAME_DESC:
      return UserDriverDownloadRequestOrder.TAXI_CORPORATION_DISPLAY_NAME_DESC;
    case UserDriverDownloadParamsOrder.LAST_PLAN_ENTRY_END_TIME_ASC:
      return UserDriverDownloadRequestOrder.LAST_PLAN_ENTRY_END_TIME_ASC;
    case UserDriverDownloadParamsOrder.LAST_PLAN_ENTRY_END_TIME_DESC:
      return UserDriverDownloadRequestOrder.LAST_PLAN_ENTRY_END_TIME_DESC;
    case UserDriverDownloadParamsOrder.CREATED_AT_ASC:
      return UserDriverDownloadRequestOrder.CREATED_AT_ASC;
    case UserDriverDownloadParamsOrder.CREATED_AT_DESC:
      return UserDriverDownloadRequestOrder.CREATED_AT_DESC;
    case UserDriverDownloadParamsOrder.MODIFIED_AT_ASC:
      return UserDriverDownloadRequestOrder.MODIFIED_AT_ASC;
    case UserDriverDownloadParamsOrder.MODIFIED_AT_DESC:
      return UserDriverDownloadRequestOrder.MODIFIED_AT_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: UserDriverDownloadParams,
): UserDriverDownloadRequest => {
  return {
    address: params.address,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    email: params.email,
    firstName: params.firstName,
    fleetPartner: params.fleetPartner,
    fleetPartnerId: params.fleetPartnerId,
    lastName: params.lastName,
    modificationEnd: params.modificationEnd,
    modificationStart: params.modificationStart,
    order: createOrder(params.order),
    pendingCandidature: params.pendingCandidature,
    statusCriteria: createStatusCriteria(params.statusCriteria),
    taxiCorporation: params.taxiCorporation,
    taxiCorporationId: params.taxiCorporationId,
    username: params.username,
    separator: params.separator,
    timezone: createTimezone(params.timezone),
  };
};

const userDriverDownloadParamsFactory = {
  create,
};

export default userDriverDownloadParamsFactory;
